module.exports = __webpack_public_path__ + "asset/image/light-on-566f.svg";